export default "__VITE_ASSET__CtkRfrjb__"